<div class="icons-section">
  @let iconColor = colorService.neutral500() || '#7E8184';
  <span class="time-bar" #timeIcon></span>
  <!-- <kin-icon class="mouvement" name="timer" #mouvementIcon [color]="iconColor" /> -->
  <kin-icon class="video" name="video" #videoIcon [color]="iconColor" />
  <kin-icon class="slope" name="gps_stroke" #slopeIcon [color]="iconColor" />
</div>

<div class="bar-section" [style.paddingRight.px]="elevationScaleWidth">
  <app-syncro-editor-time-bar
    [duration]="mediaBlockService.effectiveTotalDuration()"
    #timeVisualiser
  />
  <div
    class="hoverable-section"
    #hoverableSection
    appHoverXPosition
    (hoverXPosition)="changeBarPostion($event)"
    (click)="setPlayerProgress()"
  >
    @if (barPosition()) {
      <div class="syncro-bar-tooltip" [style.left.px]="barPosition()">
        <p class="strong">{{ 'syncro.editor.time' | translate }} {{ hoverTime()! | timer }}</p>
        <p>
          {{ 'syncro.editor.speed' | translate }}
          <span class="strong">{{
            hoverSpeed() !== null ? hoverSpeed()!.toFixed(1) + ' km/h' : '-'
          }}</span>
        </p>
        <p>
          {{ 'syncro.editor.altitude' | translate }}
          <span class="strong">{{
            hoverAlt() !== null ? hoverAlt()!.toFixed(0) + ' m' : '-'
          }}</span>
        </p>
      </div>
      <span class="syncro-bar hover" [style.left.px]="barPosition()"></span>
    }
    @if (selectedBarLeft()) {
      <span class="syncro-bar" [style.left]="selectedBarLeft()"></span>
    }
    <!-- <app-syncro-editor-mouvement-visualizer #mouvementVisualiser /> -->
    <app-syncro-editor-video-visualizer
      [videoFile]="mediaBlockService.videoFile()"
      #videoVisualiser
    />
    <app-syncro-editor-slope-visualizer #slopeVisualiser [showElevationScale]="true" />
  </div>
</div>
